import React, { useState, useEffect } from 'react';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const SPFigureHidden: React.FC<any> = (props) => {
  const { type = 'phone', content } = props || {};

  const [show, setShow] = useState<boolean>(false);

  const [hiddenText, setHiddenText] = useState<any>('');

  useEffect(() => {
    if (type === 'name') {
      const figureStr = `${content}`;
      if (figureStr.length > 3) {
        setHiddenText(figureStr.substring(0, 1) + '***' + figureStr.substring(figureStr.length > 3 ? figureStr.length - 1 : figureStr.length));
      } else if (figureStr.length > 2) {
        setHiddenText(figureStr.substring(0, 1) + '**');
      } else {
        setHiddenText(figureStr.substring(0, 1) + '*');
      }
    }
    if (type === 'phone') {
      const figureStr = `${content}`;
      setHiddenText(figureStr.substring(0, 3) + '****' + figureStr.substring(figureStr.length - 4));
    }
    if (type === 'idCard') {
      const figureStr = `${content}`;
      setHiddenText(figureStr.substring(0, 6) + '****' + figureStr.substring(figureStr.length - 4));
    }
  }, [content, type]);

  return (
    <>
      {show ? content: hiddenText }
      <span style={{ marginLeft: 8 }}>{show ? <EyeOutlined onClick={() => setShow(false)} /> : <EyeInvisibleOutlined onClick={() => setShow(true)} /> }</span>
    </>
  )
}

export default SPFigureHidden;
